import React, {Component} from 'react';
import FileProperties from '../Properties/FileProperties'
import objeler from '../objeler';
import ModalBase from './ModaBase';

class ModalDialogFile extends Component<props> {
    constructor(props) {
        super(props);
    }

    onFileChange = (e) => {
        objeler.ModalFileParameters.FileName = e.target.value;
        console.log('objeler.ModalFileParameters.FileName', objeler.ModalFileParameters.FileName);
    }
    closeModal = (b) => {
        if (b !== "Cancel") {
            objeler.closeModalFile("dosya ismi");
        } else
            objeler.closeModalFile("Cancel");
    }

    render() {
        return (
            <div>
                <ModalBase
                    isOpen={this.props.isOpen}
                    closeModal={this.closeModal}
                    title={objeler.ModalFileParameters.Title}
                >
                    <table height="90%" style={{border: "2px"}}>
                        <tbody>
                        <tr>
                            <td scope="col" colSpan="3">
                                <FileProperties onFileChange={this.onFileChange}
                                                FileName={objeler.ModalFileParameters.FileName}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ModalBase>
            </div>
        );
    }
}

export default ModalDialogFile;